/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AuditReportsAodRuleInGetManyDto } from "./AuditReportsAodRuleInGetManyDto";

export const AuditReportsAodRunInGetManyDtoTypeEnum = {
    EOW: "EOW",
    ORDER_END: "ORDER_END",
    MANUAL: "MANUAL"
} as const;

export type AuditReportsAodRunInGetManyDtoTypeEnumKey = (typeof AuditReportsAodRunInGetManyDtoTypeEnum)[keyof typeof AuditReportsAodRunInGetManyDtoTypeEnum];

export const AuditReportsAodRunInGetManyDtoStatusEnum = {
    WAITING: "WAITING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED_WITH_EXPORT: "COMPLETED_WITH_EXPORT",
    COMPLETED_WITHOUT_EXPORT: "COMPLETED_WITHOUT_EXPORT",
    WAITING_FOR_REPROCESS: "WAITING_FOR_REPROCESS",
    FAILED: "FAILED"
} as const;

export type AuditReportsAodRunInGetManyDtoStatusEnumKey = (typeof AuditReportsAodRunInGetManyDtoStatusEnum)[keyof typeof AuditReportsAodRunInGetManyDtoStatusEnum];

export const AuditReportsAodRunInGetManyDtoUserStatusEnum = {
    ACCEPTED: "ACCEPTED",
    REFRESHED: "REFRESHED",
    REPROCESSED: "REPROCESSED"
} as const;

export type AuditReportsAodRunInGetManyDtoUserStatusEnumKey = (typeof AuditReportsAodRunInGetManyDtoUserStatusEnum)[keyof typeof AuditReportsAodRunInGetManyDtoUserStatusEnum];

export type AuditReportsAodRunInGetManyDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined, date-time
    */
    scheduledDatetime?: string;
    /**
     * @type string
    */
    type: AuditReportsAodRunInGetManyDtoTypeEnumKey;
    /**
     * @type string
    */
    status: AuditReportsAodRunInGetManyDtoStatusEnumKey;
    /**
     * @type string
    */
    userStatus: AuditReportsAodRunInGetManyDtoUserStatusEnumKey;
    /**
     * @type string | undefined
    */
    reportId?: string;
    /**
     * @type string
    */
    order: string;
    /**
     * @type string | undefined
    */
    interval?: string;
    /**
     * @description Number of times this run was executed (processed by ProcessAodRunJob).
     * @type number
    */
    executionCount: number;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @type number | undefined
    */
    efficiency?: number;
    /**
     * @type object
    */
    rule: AuditReportsAodRuleInGetManyDto;
};